import { config, gameState } from '@js/state';

var attempts = 0;
var hintOn = false;

var finalRouteMap_Q10 = [];

var entryPoint = [0, 0];

var selectedCount_Q10 = 0;

var routeMapSet_Q10 = 1;

var newPointDistanceQ10 = 0;

var plantArrayQ10 = [[], [], [], [], [], [], [], [], []];

var plantLeftArrayQ10 = [[], [], [], [], [], [], [], [], [], []];

var leftEntrance_Q10 = new Phaser.Geom.Point(434, -200);

var array1_Q10 = [];

var leftQ10_p1 = new Phaser.Geom.Point(350, 149);
var leftQ10_p2 = new Phaser.Geom.Point(130, 179);
var leftQ10_p3 = new Phaser.Geom.Point(130, 284);
var leftQ10_p4 = new Phaser.Geom.Point(350, 254);

// var leftQ10_p6 = new Phaser.Geom.Point(40, 203);
// var leftQ10_p7 = new Phaser.Geom.Point(40, 326);
// var leftQ10_p8 = new Phaser.Geom.Point(120, 326);
// var leftQ10_p9 = new Phaser.Geom.Point(200, 326);

var leftExitWay_Q10 = new Phaser.Geom.Point(200, 900);

var leftFinalRouteMap_Q10 = [leftEntrance_Q10, leftQ10_p1, leftQ10_p2, leftQ10_p3, leftQ10_p4, leftExitWay_Q10];

var leftRouteMapSet_Q10 = 1;

Array.prototype.insert = function (index, item) {
  this.splice(index, 0, item);
};

var entrance_Q10 = new Phaser.Geom.Point(0, 0);

var exitWay_Q10 = new Phaser.Geom.Point(0, 0);

var Q10_p1 = new Phaser.Geom.Point(757, 151);
var Q10_p2 = new Phaser.Geom.Point(956, 151);
var Q10_p3 = new Phaser.Geom.Point(757, 230);
var Q10_p4 = new Phaser.Geom.Point(956, 230);
var Q10_p5 = new Phaser.Geom.Point(757, 310);
var Q10_p6 = new Phaser.Geom.Point(956, 310);
var Q10_p7 = new Phaser.Geom.Point(757, 390);
var Q10_p8 = new Phaser.Geom.Point(956, 390);
var Q10_p9 = new Phaser.Geom.Point(757, 470);
var Q10_p10 = new Phaser.Geom.Point(956, 470);

export default class GameSceneQ10 extends Phaser.Scene {
  constructor() {
    super({
      key: "GameSceneQ10",
    });
  }

  preload() {
    this.load.image("BGQ10", "assets/Q10/BGQ10.png");

    this.load.image("D_BGQ10", "assets/Q10/D_BGQ10.png");
    this.load.image("L_curbQ10", "assets/Q10/L_curbQ10.png");

    this.load.image("hitBoxQ10", "assets/Q10/hitBoxQ10.png");
    this.load.image("curbQ10", "assets/Q10/curbQ10.png");
    this.load.image("rightPlotQ10", "assets/Q10/rightPlotQ10.png");

    // this.load.image("Q10_qn", "assets/Q10/Q10_qn.png");
    // this.load.image("Q10_ans", "assets/Q10/Q10_ans.png");

    this.load.image("whiteBoxQ10", "assets/Q10/whiteBoxQ10.png");

    this.load.image("leftGreyBoxQ10", "assets/Q10/leftGreyBoxQ10.png");
  }

  create() {
    this.cameras.main.fadeIn(1500, 255, 255, 255);

    config.audio.bgaudio = this.sound.add("bgaudio").setVolume(0.02);
    config.audio.bgaudio.play();

    config.audio.hintAlert = this.sound.add("hintAlert").setVolume(0.05);
    config.audio.hover = this.sound.add("hover").setVolume(0.05);
    config.audio.correctAnswer = this.sound.add("correctAnswer").setVolume(0.05);
    config.audio.wrongAnswer = this.sound.add("wrongAnswer").setVolume(0.05);

    config.audio.waterCan = this.sound.add("waterCan").setVolume(0.05);
    config.audio.watering = this.sound.add("watering").setVolume(0.05);

    config.audio.sunShining = this.sound.add("sunShining").setVolume(0.05);
    config.audio.flowerBlossoming = this.sound.add("flowerBlossoming").setVolume(0.05);

    this.BGQ10 = this.add.sprite(config.width / 2, config.height / 2, "D_BGQ10");

    this.progressBar = this.add.sprite(497.81, -12.89, "progressBar").setOrigin(0);

    this.correctGreen_1 = this.add.sprite(510, 17, "correctGreen").setOrigin(0).setDepth(0);

    this.deselectText = this.add
      .sprite(config.width / 2, config.height / 2, "deselectText")
      .setDepth(1)
      .setVisible(false);
    this.hand = this.add.sprite(783, 179, "hand").setOrigin(-0.3, -0.1).setVisible(false).setDepth(6);
    this.correctGreen_2 = this.add.sprite(552, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_3 = this.add.sprite(594, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_4 = this.add.sprite(636, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_5 = this.add.sprite(678, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);
    this.correctGreen_6 = this.add.sprite(719.2, 17, "correctGreen").setOrigin(0).setDepth(0).setVisible(false);

    this.scoreRefresh();

    this.addWaterButton = this.add.sprite(860, 624, "addWaterButton").setInteractive({ cursor: "pointer" }).setOrigin(0);

    this.curbQ10 = this.add.sprite(724, 118, "L_curbQ10").setOrigin(0).setDepth(2);
    this.add.sprite(756, 151, "rightPlotQ10").setOrigin(0).setDepth(2);

    this.hitBoxQ10_1 = this.add.sprite(757, 151, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_2 = this.add.sprite(956, 151, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_3 = this.add.sprite(757, 230, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_4 = this.add.sprite(956, 230, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_5 = this.add.sprite(757, 310, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_6 = this.add.sprite(956, 310, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_7 = this.add.sprite(757, 390, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_8 = this.add.sprite(956, 390, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_9 = this.add.sprite(757, 470, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);
    this.hitBoxQ10_10 = this.add.sprite(956, 470, "hitBoxQ10").setInteractive({ cursor: "pointer" }).setOrigin(0).setAlpha(0.1).setDepth(2);

    this.whiteBoxQ10_1 = this.add.sprite(757, 151, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_2 = this.add.sprite(956, 151, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_3 = this.add.sprite(757, 230, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_4 = this.add.sprite(956, 230, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_5 = this.add.sprite(757, 310, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_6 = this.add.sprite(956, 310, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_7 = this.add.sprite(757, 390, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_8 = this.add.sprite(956, 390, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_9 = this.add.sprite(757, 470, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);
    this.whiteBoxQ10_10 = this.add.sprite(956, 470, "whiteBoxQ10").setOrigin(0).setVisible(false).setDepth(2);

    ///

    this.leftGreyBoxQ10 = this.add.sprite(118, 150, "leftGreyBoxQ10").setOrigin(0).setVisible(false);

    this.anims.create({
      key: "sunrise",
      frames: this.anims.generateFrameNames("sunAnim", {
        start: 0,
        end: 348,
        zeroPad: 0,
        prefix: "sunAnim",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.anims.create({
      key: "shake",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 1,
        end: 27,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: "idle",
      frames: this.anims.generateFrameNames("wrongPlacardAnim", {
        start: 0,
        end: 0,
        zeroPad: 0,
        prefix: "wrongPlacard",
        suffix: ".png",
      }),
      frameRate: 20,
      repeat: 0,
    });

    // this.Q10_ans = this.add.sprite(654.14,474.2, "qnBoard").setOrigin(0);

    this.Q10_ans = this.add.sprite(0, 0, "wrongPlacardAnim").setOrigin(0).setDepth(2);

    this.Q10_qn = this.add.sprite(20.14, 473.2, "qnBoard").setOrigin(0);

    this.sun = this.add.sprite(0, 0, "sunAnim").setOrigin(0).setDepth(8);

    this.leftLine = this.add.sprite(55, 547, "line").setOrigin(0);
    this.rightLine = this.add.sprite(691, 548, "line").setOrigin(0).setDepth(2);

    this.inputWindow = this.add.sprite(690, 500, "inputWindow").setOrigin(0);

    this.Q10_leftNr = this.add.text(78, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true);
    this.Q10_leftDr = this.add.text(78, 578, "8", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5);

    this.Q10_input = this.add.text(715, 523, "0", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setVisible(true).setDepth(2);
    this.Q10_rightDr = this.add.text(715, 578, "10", { fontFamily: "font1", fontSize: "40px", fill: "#2b2b2b" }).setOrigin(0.5, 0.5).setDepth(2);

    this.can = this.add.sprite(-200, -200, "wateringCanAnim").setOrigin(0.4, 0.7).setDepth(6);
    this.add.sprite(692.22, 646.37, "grass").setOrigin(0).setDepth(2);

    this.anims.create({
      key: "floweringQ10",
      frames: this.anims.generateFrameNames("flowering1Anim", {
        start: 30,
        end: 75,
        zeroPad: 0,
        prefix: "FLOWER",
        suffix: ".png",
      }),
      frameRate: 40,
      repeat: 0,
    });

    // this.hitboxClickAndHoverHandle();
    // this.handleAddWaterButton();

    //>1

    this.hint = this.add.sprite(255, 552, "hint_1").setScale(0.8).setVisible(false).setDepth(7);

    this.closeHintButton = this.add.sprite(445, 450, "closeHint").setVisible(false).setDepth(7).setInteractive({ cursor: "pointer" });

    // this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7).setInteractive({ cursor: "pointer" });

    this.hintButton = this.physics.add.sprite(80, 650, "hintFinalAnim").setScale(0.8).setDepth(7);

    this.anims.create({
      key: "pop",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: "breathe",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "idlehint",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: "pop_out",
      frames: this.anims.generateFrameNames("hintFinalAnim", {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: "seq_0_",
        suffix: ".png",
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.overlay = this.add
      .sprite(config.width / 2, config.height / 2, "overlay")
      .setBlendMode(Phaser.BlendModes.MULTIPLY)
      .setVisible(false);

    this.handleHintButton();

    //<1

    this.waterPlantOnLeftQ10();
  }

  waterPlantOnLeftQ10() {
    this.time.delayedCall(
      1500,
      () => {
        this.leftGreyBoxQ10.setVisible(true);

        this.moveCanInitial(leftFinalRouteMap_Q10[0].x, leftFinalRouteMap_Q10[0].y, leftFinalRouteMap_Q10[1].x, leftFinalRouteMap_Q10[1].y);
      },
      [],
      this
    );
  }

  startQuestionQ10() {
    //>//>>>hidden_console.log("startQ10");

    this.hitboxClickAndHoverHandle();
    this.handleAddWaterButton();
  }

  toggleHit(hitboxname, xcode, ycode) {
    this.hideDeselect();

    if (hitboxname.alpha == 0.1) {
      hitboxname.setAlpha(1);

      this.updateRouteMap(xcode, ycode);

      selectedCount_Q10 += 1;

      this.Q10_input.setText(selectedCount_Q10);
    } else {
      hitboxname.setAlpha(0.1);

      Phaser.Utils.Array.Remove(array1_Q10, this.getPointFromCode(xcode, ycode));

      selectedCount_Q10 -= 1;
      this.Q10_input.setText(selectedCount_Q10);
    }
  }

  moveCanInitial(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(0);
        // leafArray[startRouteCount-1].play("plantbudding").setVisible(true);

        // this.createPlants(leftFinalRouteMap_Q10[leftRouteMapSet_Q10-1],leftRouteMapSet_Q10-1);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createLeftPlants(leftFinalRouteMap_Q10[leftRouteMapSet_Q10 - 1], leftRouteMapSet_Q10 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (leftRouteMapSet_Q10 < leftFinalRouteMap_Q10.length - 1) {
          this.Q10_leftNr.setText(leftRouteMapSet_Q10);

          this.moveCanInitial(leftFinalRouteMap_Q10[leftRouteMapSet_Q10].x, leftFinalRouteMap_Q10[leftRouteMapSet_Q10].y, leftFinalRouteMap_Q10[leftRouteMapSet_Q10 + 1].x, leftFinalRouteMap_Q10[leftRouteMapSet_Q10 + 1].y);

          leftRouteMapSet_Q10 = leftRouteMapSet_Q10 + 1;
          // //>//>>>hidden_console.log(leftRouteMapSet_Q10);
        } else {
          this.Q10_leftNr.setVisible(true);
          this.Q10_input.setVisible(true);

          this.startQuestionQ10();
        }
      },
      onCompleteScope: this,
    });
  }

  buddingToFlowering() {
    config.audio.flowerBlossoming.play();

    for (var k5 = 0; k5 < plantLeftArrayQ10.length; k5++) {
      for (var l5 = 0; l5 < plantLeftArrayQ10[k5].length; l5++) {
        plantLeftArrayQ10[k5][l5].setTexture("flowering1Anim").play("floweringQ10");

        //>//>>>hidden_console.log(l5 + " " + k5);
      }
    }

    // plantLeftArrayQ10[1][1].setTexture("flowering1Anim").play("floweringQ10");

    for (var k = 0; k < plantArrayQ10.length; k++) {
      for (var l = 0; l < plantArrayQ10[k].length; l++) {
        plantArrayQ10[k][l].setTexture("flowering1Anim").play("floweringQ10");
      }
    }

    // this.time.delayedCall(5000, () => {

    //   this.scene.stop("GameSceneQ10");
    //   this.scene.start('EndScene');

    // },[],this);

    this.changeScene();
  }

  changeScene() {
    //>//>>>hidden_console.log("ready to change scene");
    gameState.attempted = gameState.attempted + 1;

    this.tweens.add({
      targets: config.audio.bgaudio,
      volume: 0.005,
      duration: 4000,
      onComplete: () => {},
    });

    this.time.delayedCall(
      3000,
      function () {
        this.time.delayedCall(
          1000,
          function () {
            this.cameras.main.fadeOut(1000, 255, 255, 255);
          },
          [],
          this
        );

        this.cameras.main.once(
          "camerafadeoutcomplete",
          function (camera) {
            config.audio.bgaudio.stop();
            config.audio.flowerBlossoming.stop();
            config.audio.sunShining.stop();

            attempts = 0;

            this.wipeSceneQ10();

            if (gameState.score >= 5) {
              gameState.gameWin = true;
              this.scene.stop("GameSceneQ10");
              this.scene.start("EndScene");
            } else if (gameState.attempted == 9) {
              gameState.gameWin = false;
              this.scene.stop("GameSceneQ10");
              this.scene.start("EndScene");
            } else {
              this.scene.stop("GameSceneQ10");
              this.scene.start("EndScene");
            }

            this.cameras.main.fadeIn(1000, 255, 255, 255);

            // this.time.delayedCall(
            //   2000,
            //   function () {
            // this.cameras.main.fadeIn(1000, 255, 255, 255);
            //   },
            //   [],
            //   this
            // );
          },
          this
        );

        if (gameState.attempted == 10) {
          gameState.gameWin = false;
          // this.scene.stop("TutorialScene");
          this.scene.start("EndScene");
        }
      },
      [],
      this
    );
  }

  wipeSceneQ10() {
    attempts = 0;
    hintOn = false;

    finalRouteMap_Q10 = [];

    entryPoint = [0, 0];

    selectedCount_Q10 = 0;

    routeMapSet_Q10 = 1;

    newPointDistanceQ10 = 0;

    plantArrayQ10 = [[], [], [], [], [], [], [], [], [], [], []];

    plantLeftArrayQ10 = [[], [], [], [], [], [], [], [], [], []];

    // leftFinalRouteMap_Q10 = [leftEntrance_Q10,leftQ10_p1,leftExitWay_Q10];
    leftRouteMapSet_Q10 = 1;

    entrance_Q10.setTo(0, 0);

    exitWay_Q10.setTo(0, 0);

    array1_Q10 = [];
  }

  updateRouteMap(xcode, ycode) {
    array1_Q10.push(this.getPointFromCode(xcode, ycode));
  }

  getPointFromCode(xcode, ycode) {
    if (xcode == 0 && ycode == 0) {
      return Q10_p1;
    } else if (xcode == 1 && ycode == 0) {
      return Q10_p2;
    } else if (xcode == 0 && ycode == 1) {
      return Q10_p3;
    } else if (xcode == 1 && ycode == 1) {
      return Q10_p4;
    } else if (xcode == 0 && ycode == 2) {
      return Q10_p5;
    } else if (xcode == 1 && ycode == 2) {
      return Q10_p6;
    } else if (xcode == 0 && ycode == 3) {
      return Q10_p7;
    } else if (xcode == 1 && ycode == 3) {
      return Q10_p8;
    } else if (xcode == 0 && ycode == 4) {
      return Q10_p9;
    } else if (xcode == 1 && ycode == 4) {
      return Q10_p10;
    }
  }

  scoreUpdate() {
    gameState.score = gameState.score + 1;

    //>//>>>hidden_console.log("score: " + gameState.score);

    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  pathFinding() {
    finalRouteMap_Q10.push(array1_Q10[0]);

    array1_Q10.splice(0, 1);

    ////>//>>>hidden_console.log(array1_Q10)

    for (let i = 0; i < finalRouteMap_Q10.length; i++) {
      var distanceArray = [];
      for (let j = 0; j < array1_Q10.length; j++) {
        // var dist = Math.sqrt(Math.pow(finalRouteMap_Q10[i][0] - array1_Q10[j][0], 2) + Math.pow(finalRouteMap_Q10[i][1] - array1_Q10[j][1], 2));
        var dist = Phaser.Math.Distance.BetweenPoints(finalRouteMap_Q10[i], array1_Q10[j]);
        distanceArray.push(dist);
      }
      var index = distanceArray.indexOf(Math.min(...distanceArray));

      finalRouteMap_Q10.push(array1_Q10[index]);
      array1_Q10.splice(index, 1);
      //>//>>>hidden_console.log(finalRouteMap_Q10);

      if (finalRouteMap_Q10.length == 5) {
        break;
      }
    }
  }

  handleAddWaterButton() {
    this.addWaterButton.on("pointerover", () => {
      this.addWaterButton.setTexture("hover_addWaterButton");
    });
    this.addWaterButton.on("pointerout", () => {
      this.addWaterButton.setTexture("addWaterButton");
    });
    this.addWaterButton.on("pointerup", () => {
      this.removeClicking();

      if (selectedCount_Q10 == 5) {
        this.pathFinding();

        config.audio.correctAnswer.play();
        this.tweens.add({
          targets: this.addWaterButton,
          duration: 500,
          ease: "easeInOutSine",
          //delay: 100,
          yoyo: false,
          // x: {from:783, to:1069},
          y: { from: 624, to: 800 },
          // scale: {from:1, to:0.8},
          loop: 0,
        });

        //>2

        this.hintButton.removeInteractive();
        this.hideDeselect();

        if (hintOn == true) {
          this.hintButton.play("pop_out");
          hintOn = false;
        }

        //gameState.score = gameState.score + 1;

        //>//>>>hidden_console.log("score: " + gameState.score);

        //<2

        this.Q10_ans.setTint(0xffffff);

        this.removeClicking();

        this.scoreUpdate();

        if (finalRouteMap_Q10[0] == Q10_p1) {
          entrance_Q10.setTo(727, -200);
        } else if (finalRouteMap_Q10[0] == Q10_p2) {
          entrance_Q10.setTo(844, -200);
        } else if (finalRouteMap_Q10[0] == Q10_p3) {
          entrance_Q10.setTo(961, -200);
        } else if (finalRouteMap_Q10[0] == Q10_p4) {
          entrance_Q10.setTo(2078, 203);
        } else if (finalRouteMap_Q10[0] == Q10_p5) {
          entrance_Q10.setTo(727, 900);
        } else if (finalRouteMap_Q10[0] == Q10_p6) {
          entrance_Q10.setTo(844, 900);
        } else if (finalRouteMap_Q10[0] == Q10_p7) {
          entrance_Q10.setTo(961, 900);
        } else if (finalRouteMap_Q10[0] == Q10_p8) {
          entrance_Q10.setTo(2078, 326);
        } else if (finalRouteMap_Q10[0] == Q10_p9) {
          entrance_Q10.setTo(961, 900);
        } else if (finalRouteMap_Q10[0] == Q10_p10) {
          entrance_Q10.setTo(2078, 326);
        }

        finalRouteMap_Q10.unshift(entrance_Q10);

        if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p1) {
          exitWay_Q10.setTo(727, -200);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p2) {
          exitWay_Q10.setTo(844, -200);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p3) {
          exitWay_Q10.setTo(961, -200);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p4) {
          exitWay_Q10.setTo(2078, 203);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p5) {
          exitWay_Q10.setTo(727, 900);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p6) {
          exitWay_Q10.setTo(844, 900);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p7) {
          exitWay_Q10.setTo(961, 900);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p8) {
          exitWay_Q10.setTo(2078, 326);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p9) {
          exitWay_Q10.setTo(961, 900);
        } else if (finalRouteMap_Q10[finalRouteMap_Q10.length - 1] == Q10_p10) {
          exitWay_Q10.setTo(2078, 326);
        }

        finalRouteMap_Q10.push(exitWay_Q10);

        this.moveCan(finalRouteMap_Q10[0].x, finalRouteMap_Q10[0].y, finalRouteMap_Q10[1].x, finalRouteMap_Q10[1].y);
      } else {
        config.audio.wrongAnswer.play();

        //>3

        this.incorrectAttempt();

        this.hintButton.removeInteractive();

        //<3

        // this.Q10_ans.setTint(0xFFC2A2);

        this.Q10_ans.play("shake");

        this.inputWindow.setVisible(false);

        this.rightLine.setTexture("redLine");

        this.Q10_rightDr.setFill("#C22300");
        this.Q10_input.setFill("#C22300");

        this.time.delayedCall(
          2500,
          () => {
            this.Q10_ans.play("idle");
            this.inputWindow.setVisible(true);

            this.rightLine.setTexture("line");

            this.Q10_rightDr.setFill("#2b2b2b");
            this.Q10_input.setFill("#2b2b2b");
          },
          [],
          this
        );
      }
    });
  }
  //>4
  handleHintButton() {
    this.hintButton.on(
      "pointerup",
      function (pointer) {
        ////
        gameState.hints += 1;

        this.hintButton.setVisible(true);

        this.hintButton.play("idlehint");

        this.removeClicking();

        if (attempts == 1) {
          this.hint.setTexture("hint_1");

          this.overlay.setVisible(true).setDepth(6);
          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
        } else if (attempts >= 2) {
          this.overlay.setVisible(true).setDepth(6);

          this.hint.setVisible(true);
          this.closeHintButton.setVisible(true);
          this.hint.setTexture("hint_2");
        }
      },
      this
    );

    this.closeHintButton.on(
      "pointerup",
      function (pointer) {
        this.enableClicking();

        this.overlay.setVisible(false);
        this.hint.setVisible(false);
        this.closeHintButton.setVisible(false);
        this.hintButton.play("pop_out");
        this.hintButton.removeInteractive();

        hintOn = false;
      },
      this
    );
  }

  incorrectAttempt() {
    // correctAnswer = false;
    this.hintButton.setVisible(false);

    // ////

    attempts += 1;

    if (attempts == 1 || attempts == 2) {
      this.showDeselect();
    } else {
      this.addWaterButton.setTexture("disable_addWaterButton");
    }
    //>//>>>hidden_console.log(attempts);

    this.time.delayedCall(
      1000,
      function () {
        if (attempts == 1 || attempts == 2) {
          hintOn = true;

          this.hintButton.setVisible(true);

          this.hintButton.play("pop");
          config.audio.hintAlert.play();

          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );

          this.time.delayedCall(
            500,
            function () {
              if (hintOn) {
                this.hintButton.play("breathe");
              }
            },
            [],
            this
          );
        }
      },
      [],
      this
    );

    this.time.delayedCall(
      1800,
      function () {
        if (attempts == 1 || attempts == 2) {
          this.time.delayedCall(
            1300,
            () => {
              this.enableClicking();

              this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });
            },
            [],
            this
          );
        } else {
          this.removeClicking();
          this.changeScene();

          if (hintOn == true) {
            this.hintButton.play("pop_out");
            hintOn = false;
          }

          this.time.delayedCall(
            3300,
            function () {
              attempts = 0;
            },
            [],
            this
          );
        }
      },
      [],
      this
    );
  }

  //<4

  calculateDistance(target1, target2) {
    return Phaser.Math.Distance.BetweenPoints(target1, target2);
  }

  moveCan(fromX, fromY, toX, toY) {
    this.time.delayedCall(
      1800,
      () => {
        this.waterThePlant(100);
      },
      [],
      this
    );

    this.time.delayedCall(
      1000,
      () => {
        this.createPlants(finalRouteMap_Q10[routeMapSet_Q10 - 1], routeMapSet_Q10 - 1);
      },
      [],
      this
    );

    this.tweens.add({
      targets: this.can,
      duration: 1500,
      ease: "Cubic",
      delay: 500,
      yoyo: false,
      x: { from: fromX, to: toX },
      y: { from: fromY, to: toY },
      completeDelay: 500,
      onComplete: () => {
        if (routeMapSet_Q10 < finalRouteMap_Q10.length - 1) {
          this.moveCan(finalRouteMap_Q10[routeMapSet_Q10].x, finalRouteMap_Q10[routeMapSet_Q10].y, finalRouteMap_Q10[routeMapSet_Q10 + 1].x, finalRouteMap_Q10[routeMapSet_Q10 + 1].y);

          routeMapSet_Q10 = routeMapSet_Q10 + 1;
          //>//>>>hidden_console.log(routeMapSet_Q10);
        } else {
          config.audio.sunShining.play();

          this.tweens.add({
            targets: config.audio.sunShining,
            volume: 0.005,
            duration: 3000,
            onComplete: () => {},
          });

          this.sun.play("sunrise");

          this.time.delayedCall(
            3000,
            () => {
              this.buddingToFlowering();
              config.audio.sunShining.stop();
            },
            [],
            this
          );
        }
      },
      onCompleteScope: this,
    });
  }
  showDeselect() {
    if (selectedCount_Q10 >= 5) {
      if (!gameState.firstMistake) {
        this.deselectText.setVisible(true);

        this.hand.setVisible(true);
        this.tweens.add({
          targets: this.hand,
          duration: 500,
          ease: "easeInOutSine",
          // delay: 500,
          yoyo: true,
          // x: {from:783, to:1069},
          // y: {from:179, to:640},
          scale: { from: 1, to: 0.8 },
          loop: -1,
        });

        this.hand.setPosition(array1_Q10[0].x, array1_Q10[0].y);
      }

      gameState.firstMistake = true;
    }
  }

  hideDeselect() {
    this.deselectText.setVisible(false);
    this.hand.setVisible(false);
  }

  hitboxClickAndHoverHandle() {
    this.BGQ10.setTexture("BGQ10");
    this.curbQ10.setTexture("curbQ10");
    this.hitBoxQ10_1.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_1, 0, 0);
      },
      this
    );
    this.hitBoxQ10_2.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_2, 1, 0);
      },
      this
    );
    this.hitBoxQ10_3.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_3, 0, 1);
      },
      this
    );
    this.hitBoxQ10_4.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_4, 1, 1);
      },
      this
    );
    this.hitBoxQ10_5.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_5, 0, 2);
      },
      this
    );
    this.hitBoxQ10_6.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_6, 1, 2);
      },
      this
    );
    this.hitBoxQ10_7.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_7, 0, 3);
      },
      this
    );
    this.hitBoxQ10_8.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_8, 1, 3);
      },
      this
    );
    this.hitBoxQ10_9.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_9, 0, 4);
      },
      this
    );
    this.hitBoxQ10_10.on(
      "pointerup",
      () => {
        this.toggleHit(this.hitBoxQ10_10, 1, 4);
      },
      this
    );

    this.hitBoxQ10_1.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(1);
      },
      this
    );
    this.hitBoxQ10_2.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(2);
      },
      this
    );
    this.hitBoxQ10_3.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(3);
      },
      this
    );
    this.hitBoxQ10_4.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(4);
      },
      this
    );
    this.hitBoxQ10_5.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(5);
      },
      this
    );
    this.hitBoxQ10_6.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(6);
      },
      this
    );
    this.hitBoxQ10_7.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(7);
      },
      this
    );
    this.hitBoxQ10_8.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(8);
      },
      this
    );
    this.hitBoxQ10_9.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(9);
      },
      this
    );
    this.hitBoxQ10_10.on(
      "pointerover",
      () => {
        this.showWhiteBoxQ10(10);
      },
      this
    );

    this.hitBoxQ10_1.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_2.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_3.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_4.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_5.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_6.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_7.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_8.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_9.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
    this.hitBoxQ10_10.on(
      "pointerout",
      () => {
        this.removeWhiteBoxQ10();
      },
      this
    );
  }

  scoreRefresh() {
    //>//>>>hidden_console.log("score: " + gameState.score);
    if (gameState.score >= 1) {
      this.correctGreen_2.setVisible(true);
    }
    if (gameState.score >= 2) {
      this.correctGreen_3.setVisible(true);
    }
    if (gameState.score >= 3) {
      this.correctGreen_4.setVisible(true);
    }
    if (gameState.score >= 4) {
      this.correctGreen_5.setVisible(true);
    }
    if (gameState.score >= 5) {
      this.correctGreen_6.setVisible(true);
    }
  }

  enableClicking() {
    this.hitBoxQ10_1.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_2.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_3.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_4.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_5.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_6.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_7.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_8.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_9.setInteractive({ cursor: "pointer", pixelPerfect: true });
    this.hitBoxQ10_10.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.hintButton.setInteractive({ cursor: "pointer", pixelPerfect: true });

    this.addWaterButton.setInteractive({ cursor: "pointer" });
    this.addWaterButton.setTexture("addWaterButton");
  }

  ///<5

  removeClicking() {
    this.hitBoxQ10_1.removeInteractive();
    this.hitBoxQ10_2.removeInteractive();
    this.hitBoxQ10_3.removeInteractive();
    this.hitBoxQ10_4.removeInteractive();
    this.hitBoxQ10_5.removeInteractive();
    this.hitBoxQ10_6.removeInteractive();
    this.hitBoxQ10_7.removeInteractive();
    this.hitBoxQ10_8.removeInteractive();
    this.hitBoxQ10_9.removeInteractive();
    this.hitBoxQ10_10.removeInteractive();

    this.addWaterButton.removeInteractive();
    if (attempts == 0 || attempts == 1) {
      this.addWaterButton.setTexture("addWaterButton");
    }

    this.hintButton.removeInteractive();
  }

  showWhiteBoxQ10(position) {
    config.audio.hover.play();

    this.removeWhiteBoxQ10();
    if (position == 1) {
      this.whiteBoxQ10_1.setVisible(true);
    }
    if (position == 2) {
      this.whiteBoxQ10_2.setVisible(true);
    }
    if (position == 3) {
      this.whiteBoxQ10_3.setVisible(true);
    }
    if (position == 4) {
      this.whiteBoxQ10_4.setVisible(true);
    }
    if (position == 5) {
      this.whiteBoxQ10_5.setVisible(true);
    }
    if (position == 6) {
      this.whiteBoxQ10_6.setVisible(true);
    }
    if (position == 7) {
      this.whiteBoxQ10_7.setVisible(true);
    }
    if (position == 8) {
      this.whiteBoxQ10_8.setVisible(true);
    }
    if (position == 9) {
      this.whiteBoxQ10_9.setVisible(true);
    }
    if (position == 10) {
      this.whiteBoxQ10_10.setVisible(true);
    }
  }

  removeWhiteBoxQ10() {
    this.whiteBoxQ10_1.setVisible(false);
    this.whiteBoxQ10_2.setVisible(false);
    this.whiteBoxQ10_3.setVisible(false);
    this.whiteBoxQ10_4.setVisible(false);
    this.whiteBoxQ10_5.setVisible(false);
    this.whiteBoxQ10_6.setVisible(false);
    this.whiteBoxQ10_7.setVisible(false);
    this.whiteBoxQ10_8.setVisible(false);
    this.whiteBoxQ10_9.setVisible(false);
    this.whiteBoxQ10_10.setVisible(false);
  }

  createPlants(selectedPoint, plantSelectionCode) {
    plantArrayQ10[plantSelectionCode][0] = this.add
      .sprite(selectedPoint.x + 25, selectedPoint.y, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
    plantArrayQ10[plantSelectionCode][1] = this.add
      .sprite(selectedPoint.x + 70, selectedPoint.y, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false)
      .setDepth(5);

    plantArrayQ10[plantSelectionCode][2] = this.add
      .sprite(selectedPoint.x + 55, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false)
      .setDepth(5);
    plantArrayQ10[plantSelectionCode][3] = this.add
      .sprite(selectedPoint.x + 100, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);

    plantArrayQ10[plantSelectionCode][4] = this.add
      .sprite(selectedPoint.x + 115, selectedPoint.y, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false)
      .setDepth(5);
    plantArrayQ10[plantSelectionCode][5] = this.add
      .sprite(selectedPoint.x + 160, selectedPoint.y, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false)
      .setDepth(5);

    plantArrayQ10[plantSelectionCode][6] = this.add
      .sprite(selectedPoint.x + 145, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setVisible(false)
      .setDepth(5);
    plantArrayQ10[plantSelectionCode][7] = this.add
      .sprite(selectedPoint.x + 190, selectedPoint.y + 30, "playSwayAnim")
      .setScale(0.3)
      .play("plantbudding")
      .setDepth(5);
  }

  createLeftPlants(selectedPoint, plantSelectionCode) {
    //>//>>>hidden_console.log(plantSelectionCode);

    if (plantSelectionCode == 2 || plantSelectionCode == 3) {
      plantLeftArrayQ10[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x, selectedPoint.y - 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x + 50, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 100, selectedPoint.y + 10, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 155, selectedPoint.y + 17, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][4] = this.add
        .sprite(selectedPoint.x + 210, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    } else {
      plantLeftArrayQ10[plantSelectionCode][0] = this.add
        .sprite(selectedPoint.x - 90, selectedPoint.y - 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][1] = this.add
        .sprite(selectedPoint.x - 40, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][2] = this.add
        .sprite(selectedPoint.x + 10, selectedPoint.y, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][3] = this.add
        .sprite(selectedPoint.x + 70, selectedPoint.y + 15, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
      plantLeftArrayQ10[plantSelectionCode][4] = this.add
        .sprite(selectedPoint.x + 140, selectedPoint.y + 20, "playSwayAnim")
        .setScale(0.3)
        .play("plantbudding");
    }
  }

  waterThePlant(flowingtime) {
    if (routeMapSet_Q10 <= selectedCount_Q10 || leftRouteMapSet_Q10 < leftFinalRouteMap_Q10.length - 1) {
      config.audio.watering.play();
    }

    this.can.play("startwatering");

    this.time.delayedCall(
      1000,
      () => {
        this.can.play("waterflowing");

        this.time.delayedCall(
          flowingtime,
          () => {
            this.can.play("stopwatering");

            config.audio.watering.stop();
          },
          [],
          this
        );
      },
      [],
      this
    );
  }

  update() {}
}
